import { render } from "./configSimulatorAllotmentsComponent.vue?vue&type=template&id=b3b61138"
import script from "./configSimulatorAllotmentsComponent.vue?vue&type=script&lang=js"
export * from "./configSimulatorAllotmentsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__